module.exports = __webpack_public_path__ + "img/mascot_pro.2a4095ec.svg";